import type { RefObject } from 'react';
import { Component, createRef } from 'react';

import BpkHorizontalNav, {
  BpkHorizontalNavItem,
} from '@skyscanner/backpack-web/bpk-component-horizontal-nav';

import type { TranslationKey } from '@shared/constants/translations';
import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

import STYLES from './PanelHeader.module.scss';

import {
  THING_TO_DO,
  TRANSPORT,
} from '@hotels-hotel-detail/utils/location-constants';
import { withI18n } from '@shared/ui/contexts/i18n';
import {
  disableBodyScroll,
  enableBodyScroll,
} from '@shared/utils-frontend/body-scroll-lock';

const categoriesSaas: Record<string, TranslationKey> = {
  [THING_TO_DO]: 'Modal_label_thingsToDo',
  [TRANSPORT]: 'HotelDetail_map__transportation',
};

type Props = {
  i18n: I18nService;
  categories: string[];
  selectedTab: Nullable<string>;
  onTabClick: (categoriesName: string) => void;
};

class PanelHeader extends Component<Props> {
  navRef: RefObject<any>;

  constructor(props: Props) {
    super(props);

    this.navRef = createRef();
  }

  componentDidMount() {
    if (this.navRef && this.navRef.current) {
      disableBodyScroll(this.navRef.current.scrollRef);
    }
  }

  componentWillUnmount() {
    if (this.navRef && this.navRef.current) {
      enableBodyScroll(this.navRef.current.scrollRef);
    }
  }

  render() {
    const { categories, i18n, onTabClick, selectedTab } = this.props;
    return (
      <BpkHorizontalNav
        className={STYLES.PanelHeader__nav}
        autoScrollToSelected
        ref={this.navRef}
      >
        {categories.map((categorieName) => (
          <BpkHorizontalNavItem
            className={STYLES.PanelHeader__navItem}
            key={categorieName}
            name={categorieName}
            selected={selectedTab === categorieName}
            onClick={() => onTabClick(categorieName)}
          >
            {i18n.translate(categoriesSaas[categorieName])}
          </BpkHorizontalNavItem>
        ))}
      </BpkHorizontalNav>
    );
  }
}

export default withI18n(PanelHeader);
